module.exports = __webpack_public_path__ + "static/media/Hull colour -  pure white RAL 9010 & 3 x dark blue RAL 5011 waterlines.fe15938b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x dark blue RAL 5011 waterlines.jpg
// module id = 50
// module chunks = 0